/* Temporalis — sommaire flottant des articles (assets/tpls-floating-toc.js)
   Chargé sur les articles uniquement, par layout/theme.liquid. Desktop seulement. */
(function() {
  function initFloatingTOC() {
    // Sommaire masqué sous 1024 px (tpls-article.css) : inutile de le construire
    if (!window.matchMedia('(min-width: 1024px)').matches) return;

    var article = document.querySelector('.hdt-article-content');
    if (!article) return;

    var headings = article.querySelectorAll('h2');
    if (headings.length < 3) return;

    // Label multilingue
    var lang = (document.documentElement.lang || 'en').substring(0, 2);
    var tocTitles = {
      'fr': 'Sommaire', 'de': 'Inhalt', 'es': 'Contenido',
      'it': 'Indice', 'nl': 'Inhoud', 'pl': 'Spis treści',
      'pt': 'Índice', 'da': 'Indhold', 'sv': 'Innehåll',
      'th': 'สารบัญ'
    };
    var tocTitle = tocTitles[lang] || 'Contents';

    // Wrapper layout
    var wrapper = document.createElement('div');
    wrapper.className = 'article-layout';
    article.parentNode.insertBefore(wrapper, article);

    // Sidebar + TOC
    var sidebar = document.createElement('aside');
    sidebar.className = 'article-sidebar';

    var nav = document.createElement('nav');
    nav.className = 'floating-toc';
    nav.id = 'floating-toc';
    nav.innerHTML =
      '<div class="toc-header">' +
        '<span class="toc-title">' + tocTitle + '</span>' +
        '<div class="toc-progress"><div class="toc-progress-bar" id="toc-progress-bar"></div></div>' +
      '</div>';

    sidebar.appendChild(nav);
    wrapper.appendChild(sidebar);
    wrapper.appendChild(article);

    // Génération des liens (H2 uniquement)
    var fragment = document.createDocumentFragment();
    headings.forEach(function(h, i) {
      if (!h.id) h.id = 'section-' + i;
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.className = 'toc-link';
      a.dataset.target = h.id;
      var cleanText = h.textContent.replace(/^\d+[\.\)\-\s]+/, '').trim();
      a.innerHTML = '<span class="toc-number">' + (i + 1) + '</span> ' + cleanText;
      fragment.appendChild(a);
    });
    nav.appendChild(fragment);

    // Highlight actif via IntersectionObserver
    var currentActive = null;
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          var next = nav.querySelector('a[data-target="' + e.target.id + '"]');
          if (next && next !== currentActive) {
            if (currentActive) currentActive.classList.remove('active');
            next.classList.add('active');
            currentActive = next;
          }
        }
      });
    }, { rootMargin: '-80px 0px -70% 0px' });
    headings.forEach(function(h) { observer.observe(h); });

    // Progress bar — throttle via requestAnimationFrame + passive listener
    var progressBar = document.getElementById('toc-progress-bar');
    var ticking = false;
    var lastPct = -1;

    function updateProgress() {
      var rect = article.getBoundingClientRect();
      var scrollable = article.scrollHeight - window.innerHeight;
      if (scrollable <= 0) { ticking = false; return; }
      var scrolled = Math.max(0, -rect.top);
      var pct = Math.min(100, (scrolled / scrollable) * 100);
      // N'écrit le DOM que si le % a vraiment changé (évite reflow inutile)
      if (progressBar && Math.abs(pct - lastPct) > 0.1) {
        progressBar.style.width = pct + '%';
        lastPct = pct;
      }
      ticking = false;
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(updateProgress);
      }
    }, { passive: true });

    // Init
    updateProgress();

    // Smooth scroll via délégation (déjà le cas, on garde)
    nav.addEventListener('click', function(e) {
      var link = e.target.closest('.toc-link');
      if (!link) return;
      e.preventDefault();
      var target = document.getElementById(link.dataset.target);
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  // Lancer maintenant ou quand le DOM est prêt
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFloatingTOC);
  } else {
    initFloatingTOC();
  }
})();